var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div id=\"{{::headingId}}\" role=\"tab\" class=\"panel-heading\" ng-click=\"toggleOpen(); $parent.toggle && $parent.toggle()\">\n<h4 class=\"panel-title accordion-toggle\" role=\"button\" data-toggle=\"collapse\" uib-accordion-transclude=\"heading\" ng-disabled=\"isDisabled\">\n<span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span>\n</h4>\n</div>\n<div id=\"{{::panelId}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n<div class=\"panel-body\" ng-transclude></div>\n</div>";
var id1="public-booking/accordion-range-group/v2/time_range_accordion_group_transclude.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/public-booking/accordion-range-group/v2/time_range_accordion_group_transclude.html
// module id = 1212
// module chunks = 0